module.exports = __webpack_public_path__ + "img/bizum.3d360465.png";